import { useEffect, useMemo, useState } from "react";
import { useDebounce } from "../../src/shared/hooks";
import { useSearchParams } from "react-router-dom";
import { Routes, Route } from 'react-router-dom';
import { IListagemLocalizacao } from "../shared/services/api/estoque/localizacao/LocalizacaoService";
import { DashboardSolicitacao, DetalheSolicitacao, } from '../pages/estoque';
import { useDrawerContext } from '../shared/contexts';
import { socket } from "../shared/services/api/websocket/websocket";

export const AppRoutes = () => {
  const [rows, setRows] = useState<IListagemLocalizacao[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const { setDrawerOptions } = useDrawerContext();
  const filter = useMemo(() => {
    return searchParams.get("filter") || "";
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get("pagina") || "1");
  }, [searchParams]);

useEffect(() => {
  const params = {
    page: pagina,
    limit: 10,
  };
  setIsLoading(true);
  socket.emit("localizacao", params, (response: { data: any[]; total: number }) => {
    if (response && Array.isArray(response.data)) {
      setRows(response.data);
    } else {
      console.error("Erro ao carregar localizações");
      setRows([]);
    }
    setIsLoading(false);
  });
  const handleUpdate = (response: { data: any[]; total: number }) => {
    if (response && Array.isArray(response.data)) {
      setRows(response.data);
    }
  };
  socket.on("localizacao", handleUpdate);
  return () => {
    socket.off("localizacao", handleUpdate);
  };
}, [pagina, filter]);
  useEffect(() => {
    if (rows.length > 0) {
      const drawerItems = rows.map((localizacao) => ({
        label: localizacao.descricao,
        icon: 'person', 
        path: `solicitacao/${localizacao.idlocalizacao}`, 
        notificacao: localizacao.notificacao,
      }));

      setDrawerOptions(drawerItems);
    }
  }, [rows, setDrawerOptions]);
  return (
    <Routes>
      <Route path="/solicitacao/:id" element={<DashboardSolicitacao />} />
      <Route path="/solicitacao/detalhes/:id" element={<DetalheSolicitacao />} />
    </Routes>
  );
};